<template>
  <li :class="{ on: isOpen }">
    <div class="acd-btn" @click="toggle">
      <slot name="header"></slot>
      <IconArrow class="icon" />
    </div>

    <div class="text-box">
      <div class="inr">
        <div class="txt-area">
          <slot></slot>
        </div>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import IconArrow from '@/components/jh-app/icons/IconArrow.vue';

const isOpen = ref<boolean>(false);

const toggle = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style scoped lang="scss">
li {
  .acd-btn {
    display: flex;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid $color-gray-40;
    p {
      font-size: $font-size-psmall;
    }
    svg {
      transition: all 0.3s ease;
      transform: rotate(180deg);
    }
  }
  .text-box {
    position: relative;
    background: $gray10;
    width: calc(100% + 40px);
    left: -20px;
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.3s ease-out;
    .inr {
      overflow: hidden;
      .txt-area {
        padding: 1rem 1.25rem;
      }
    }
  }
  &.on {
    .acd-btn {
      border-bottom: 1px solid transparent;
      svg {
        transform: rotate(0);
      }
    }
    .text-box {
      grid-template-rows: 1fr;
      .inr {
      }
    }
  }
}
</style>
